import React from 'react';
import {IFileOperationsResponse} from 'types/diplomat/file_manager/FileOperationsResponse';
import api from 'api';
import ApiService from 'api/ApiService';
import {dispatchAsync} from 'redux/common';
import {useDispatch} from 'react-redux';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import {useAsyncState} from 'common/hooks/useAsyncState';
import types from 'redux/server/types';

// TODO: receive file separator from backend
export const FILE_SEPARATOR = '/';
export const UNIX_FILE_SEPARATOR = '\\';

export const useBrowseList = (onlyDirectories?: boolean) => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const {state, loading, setState, setLoading} = useAsyncState<IFileOperationsResponse>();

   const fetchBrowseList = React.useCallback(
      (path?: string, _filter?: string) => {
         setLoading(true);
         const filter = _filter?.replace(/[.*]+/gi, '');
         dispatch(
            dispatchAsync(api.fileOperations, types.POST_FILE_OPERATIONS, {
               getMethod: ApiService.postSecureJson,
               data: {
                  action: 'read',
                  path: path || FILE_SEPARATOR,
                  filter: filter || null,
                  showHiddenItems: true,
                  data: null,
                  onlyDirectories,
               },
               onSuccess: (response: IFileOperationsResponse) => {
                  if (isMountedRef.current) {
                     // const files = onlyDirectories
                     //    ? response.files.filter((f) => !f.isFile)
                     //    : response.files;
                     setState(response); // {...response, files});
                     setLoading(false);
                  }
               },
               //TODO check error code
               onError: () => {
                  if (isMountedRef.current) {
                     // if (!onlyDirectories) {
                     const pathArr = path?.split(FILE_SEPARATOR);
                     if (pathArr && pathArr.length > 1) {
                        pathArr.length -= 1;
                        fetchBrowseList(pathArr?.join(FILE_SEPARATOR));
                     } else {
                        fetchBrowseList(FILE_SEPARATOR);
                     }
                     // }
                  }
               },
            })
         );
      },
      [onlyDirectories, dispatch, isMountedRef, setLoading, setState]
   );

   return {browseList: state, loading, fileSeparator: FILE_SEPARATOR, fetchBrowseList};
};
